
import React, { Fragment, useState, useEffect } from "react";
import Header from "./../common/header";
import Footer from "./../common/footer";
import ConstructionPageBanner from "./collection-inner-construction-banner";
import ConstructionPageImage from "./collection-inner-construction-images";

import { useParams } from "react-router-dom";
import * as apiUrl from "../../apiUrl";

import logo from "../../assets/Marquis-Developers-Logo-SVG.svg";

function ConstructionPage() {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await fetch(
          `${apiUrl.apiUrl}/api/construction-update/${slug}`
        );
        if (!response.ok) {
          throw new Error("Page not found");
        }
        const data = await response.json();
        setPageData(data);
      } catch (error) {
        console.error("Error fetching page:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

   if (!pageData) {
    return <p>Page not found.</p>;
  }


  return (
    <Fragment>
      <Header />
      <ConstructionPageBanner
        bannerImage={pageData.banner_image}
        bannerTitle={pageData.banner_title}
      />
      <ConstructionPageImage
        slideImages={pageData.slide_images}
        thumbImages={pageData.thumb_images}
      />
      <Footer />
    </Fragment>
  );
}

export default ConstructionPage;
